<template>
  <div class='page-wrap'>
    <!-- head -->
    <div class="head-box">
      <div class="tipTitle">
        登录失败
      </div>
      <p class="description">
        由于您的微信版本过低，导致公<br />
        众号无法和商城进行连接
      </p>
    </div>
    <!-- content -->
    <div class="content-box">
      <div class="qr-box">
        <img src="../../../public/images/qrCode.png"
             alt="">
      </div>
      <div class="qr-des">
        请长按二维码，联系客服进行处理<br />
        或升级微信至最新版本
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  components: {},
  data () {
    return {}
  },
  created () { },
  mounted () {
    this.initShare()
  },
  methods: {
    // 初始化分享配置
    initShare () {
      const url = window.location.href
      wx.ready(function () {   //需在用户可能点击分享按钮前就先调用 
        wx.updateAppMessageShareData({
          title: 'vivo云南线上商城', // 分享标题
          desc: '识别二维码联系vivo云南客服', // 分享描述
          link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: '/images/thumbnail.png', // 分享图标
          success: function () {
            console.log()
          }
        })
      })
    },
  },
  computed: {},
  watch: {},
}
</script>

<style lang='scss' scoped>
.page-wrap {
  .head-box {
    height: 165px;
    width: 100%;
    padding: 40px 0 0 15px;
    box-sizing: border-box;
    background-image: url("../../../public/images/linkFailed.png");
    background-size: 100% 100%;
    .tipTitle {
      font-weight: 550;
      color: #333333;
      font-size: 24px;
      margin-bottom: 14px;
    }
    .description {
      color: #666666;
      font-size: 14px;
    }
  }
  .content-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 65px;
    .qr-box {
      width: 242px;
      height: 242px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .qr-des {
      margin: 14px auto;
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      text-align: center;
    }
  }
}
</style>